import {gsap} from 'gsap';

export default class TestimonialLoadMore {
    constructor() {
        this.btn = document.querySelector('.js-testimonial-load-more');
        this.wrapper = document.querySelector('.js-testimonial-wrapper');
        this.isMobile = false;

        if (window.innerWidth < 800) {
            this.isMobile = true;
            this.wrapper = document.querySelector('.js-testimonial-wrapper-mobile');
        }

        if (!this.wrapper) {
            return;
        }

        this.init();
    }

    init() {
        let height = 0;
        this.btn.addEventListener("click", () => {
            gsap.set(this.wrapper, {
                height: "auto",
                onComplete: () => {
                    height = this.wrapper.offsetHeight;

                    gsap.set(this.wrapper, {
                        height: 0,
                        onComplete: () => {
                            gsap.to(this.wrapper, 0.5, {
                                height: height,
                                onComplete: () => {
                                    this.wrapper.classList.add('is-opened');
                                    this.btn.classList.add('is-opened');
                                    this.wrapper.style.height = "auto";
                                }
                            })
                        }
                    })
                }
            })
        });
    }
}
